import { useI18n } from '../i18n';
import styles from './BookingPaymentReturnPanel.module.css';

type BookingAwaitingPaymentPanelProps = {
  bookingId: string;
  processing?: boolean;
  onPayNow: () => void;
  onClose: () => void;
};

/** Shown for Pending bookings that still need PayPlus — never as “reservation successful”. */
export function BookingAwaitingPaymentPanel({
  bookingId,
  processing = false,
  onPayNow,
  onClose,
}: BookingAwaitingPaymentPanelProps) {
  const { t } = useI18n();

  return (
    <div className={styles.panel} role="status" aria-live="polite">
      <h2 className={styles.title}>{t('bookings.payplus.awaitingTitle')}</h2>
      <p className={styles.body}>{t('bookings.payplus.awaitingBody')}</p>
      <p className={styles.hint} dir="ltr">
        {t('bookings.confirmation.bookingId')}: {bookingId}
      </p>
      <button type="button" className={styles.doneBtn} onClick={onPayNow} disabled={processing}>
        {processing ? t('bookings.payment.processing') : t('bookings.payplus.payNow')}
      </button>
      <button
        type="button"
        className={styles.doneBtn}
        style={{ marginTop: '0.55rem', background: 'transparent', color: 'inherit', border: '1px solid rgba(98,61,255,0.28)' }}
        onClick={onClose}
        disabled={processing}
      >
        {t('bookings.confirmation.close')}
      </button>
    </div>
  );
}
